/**
 * App 全体で使う型。
 *
 * @graph-stack voice-enrollment
 * @graph-domain Engineering
 * @graph-business voice-enrollment Web の状態モデルと同意バージョン定数
 * @graph-connects none
 */

import type { LanguageCode } from './i18n/index.js';

export type FlowStep = 'consent' | 'language' | 'recording' | 'success' | 'failure';

export interface CompletedRecording {
  scriptId: string;
  blob: Blob;
}

export interface AppState {
  step: FlowStep;
  language: LanguageCode;
  consentAccepted: boolean;
  recordings: CompletedRecording[];
  failureReason: string | null;
}

/** @graph-connects none */
export const CONSENT_VERSION = '2026-05';
